import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Utility } from '../../core/utils/utility';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StartupProfileService {

  apiUrl: string = `${environment.apiUrl}/Startupprofile`;

  constructor(private http: HttpClient) {
  }

  private getTenantIdFromStorage(): string | null {
    const tenantId = localStorage.getItem('tenantId');
    if (tenantId) {
      return tenantId;
    }

    const storedTenant = localStorage.getItem('tenant');
    if (!storedTenant) {
      return null;
    }

    try {
      const parsedTenant = JSON.parse(storedTenant);
      return parsedTenant?.id?.toString() || null;
    } catch (e) {
      console.warn('Error parsing tenant in StartupProfileService', e);
      return null;
    }
  }

  isMember(): Observable<any> {
    return this.http.get(`${this.apiUrl}/isMember`);
  }

  getTableForAdmin(tableState: any) {
    let params = Utility.tableStateToHttpParams(tableState);
    return this.http.get<any>(`${this.apiUrl}/admin`, { params: params });
  }

  getById(id: any): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${id}`);
  }

  getForAdmin(id: string | null): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/admin/${id}`);
  }

  getForedit(id: string | null): Observable<any> {
    return this.http
      .get<any>(`${this.apiUrl}/edit`, { params: { id: id || 0 } });
  }

  getUserProfiles(): Observable<any> {
    return this.http
      .get<any>(`${this.apiUrl}`);
  }

  get(tableState: any) {
    let params = Utility.tableStateToHttpParams(tableState);
    return this.http
      .get<any>(`${this.apiUrl}`, { params: params });
  }

  getMembers(id: any) {
    return this.http.get<any>(`${this.apiUrl}/teammates/${id}`);
  }

  getDocumentTypes(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/documentTypes`);
  }

  add(value: any): Observable<any> {
    let formData = Utility.objectToFormData(value);

    let options = {
      headers: new HttpHeaders({
        "x-none": "true",
        "enctype": "multipart/form-data",
      }),
    };

    return this.http.post(`${this.apiUrl}`, formData, options);
  }

  addByAdmin(value: any) {
    const tenantId = this.getTenantIdFromStorage();
    const payload = tenantId && !value?.tenantId ? { ...value, tenantId } : value;
    let formData = Utility.objectToFormData(payload);

    let options = {
      headers: new HttpHeaders({
        "x-none": "true",
        "enctype": "multipart/form-data",
      }),
    };

    return this.http.post(`${this.apiUrl}/admin`, formData, options);
  }


  delete(id: any) {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }

  deleteWithConfirmation(id: any, forceDelete: boolean = false) {
    return this.http.delete(`${this.apiUrl}/${id}/confirm?forceDelete=${forceDelete}`);
  }

  addTeamMember(value: any): Observable<any> {
    let formData = Utility.objectToFormData(value);

    let options = {
      headers: new HttpHeaders({
        "x-none": "true",
        "enctype": "multipart/form-data",
      }),
    };

    return this.http.post(`${this.apiUrl}/teammate`, formData, options);
  }

  addTeamMemberByAdmin(value: any): Observable<any> {
    let formData = Utility.objectToFormData(value);

    let options = {
      headers: new HttpHeaders({
        "x-none": "true",
        "enctype": "multipart/form-data",
      }),
    };

    return this.http.post(`${this.apiUrl}/admin/teammate`, formData, options);
  }


  saveDocument(value: any): Observable<any> {
    let formData = Utility.objectToFormData(value);

    let options = {
      headers: new HttpHeaders({
        "x-none": "true",
        "enctype": "multipart/form-data",
      }),
    };

    return this.http.post(`${this.apiUrl}/document`, formData, options);
  }

  update(value: any) {
    let formData = Utility.objectToFormData(value);

    let options = {
      headers: new HttpHeaders({
        "x-none": "true",
        "enctype": "multipart/form-data",
      }),
    };

    return this.http.put(`${this.apiUrl}`, formData, options);
  }

  updateLogo(value: any) {
    let formData = Utility.objectToFormData(value);

    let options = {
      headers: new HttpHeaders({
        "x-none": "true",
        "enctype": "multipart/form-data",
      }),
    };

    return this.http.post(`${this.apiUrl}/logo`, formData, options);
  }

  updateByAdmin(value: any) {
    const tenantId = this.getTenantIdFromStorage();
    const payload = tenantId && !value?.tenantId ? { ...value, tenantId } : value;
    let formData = Utility.objectToFormData(payload);

    let options = {
      headers: new HttpHeaders({
        "x-none": "true",
        "enctype": "multipart/form-data",
      }),
    };

    return this.http.put(`${this.apiUrl}/admin`, formData, options);
  }

  updateLogoByAdmin(value: any) {
    const tenantId = this.getTenantIdFromStorage();
    const payload = tenantId && !value?.tenantId ? { ...value, tenantId } : value;
    let formData = Utility.objectToFormData(payload);

    let options = {
      headers: new HttpHeaders({
        "x-none": "true",
        "enctype": "multipart/form-data",
      }),
    };

    return this.http.post(`${this.apiUrl}/admin/logo`, formData, options);
  }

  deleteTeamMember(id: any, startUpProfileId: any) {
    return this.http.delete(`${this.apiUrl}/teammate/${id}/${startUpProfileId}`);
  }

  deleteDocument(id: any) {
    return this.http.delete(`${this.apiUrl}/document/${id}`);
  }

  deleteDocumentAttachment(id: any) {
    return this.http.delete(`${this.apiUrl}/document/attachment/${id}`);
  }

  getAttachment(id: any) {
    return this.http.get(`${this.apiUrl}/document/attachment/${id}`, { responseType: 'blob' });
  }

}
